import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import history from "../../auth/history";
import UploadHistoryFileListDetails from "./UploadHistoryFileListDetails";
import UploadHistorySubComponent from "./UploadHistorySubComponent";
import Footer from "../footerComponent/Footer";
import axios from "axios";
import tokenErrorHandler from "../tokenErrorHandler";
const httpClient = axios.create();

class UploadHistory extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			bulkUploadHistory: [],
			historyLoading: 'loading',
			message: ''
		}
	}

	
	componentDidMount() {
		this.getUploadHistory();
	}
	componentWillUnmount() {
	}

	getUploadHistory = () => {

		var url = '/api/v1/billpay/corp/consumer/bulkupload-history/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}

		httpClient.get(url + this.props.agentInfo,
			{ headers }
		).then((response) => {
			var resList = [];

			if (response.data != undefined &&
				response.data != null &&
				response.data.length > 0) {
				response.data.reverse().map(res => {
					if (res.lastKnownStatus != "") {
						resList.push(res);

					}
				})

			}



			this.setState({
				bulkUploadHistory: resList,
				historyLoading: 'completed'
			})

		}).catch(error => {
			this.setState({
				historyLoading: 'completed'
			})


			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}

		});

	}


	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12">
									<div class="card">
										<div class="dashhead">
											<h3>Uploaded History</h3>
											<div class="backbtn">
												<Link to='/manage-consumer'>
													<button type="button" class="back"
													>Back</button>
												</Link>
											</div>
										</div>
										{this.state.historyLoading == 'loading' &&
											<div>Loading....
												<div class="spinner-grow spinner-grow-sm"></div>
											</div>}
										{this.state.historyLoading != 'loading' &&
											this.state.bulkUploadHistory != undefined &&
											this.state.bulkUploadHistory.length > 0 &&

											<UploadHistorySubComponent
												bulkUploadHistory={this.state.bulkUploadHistory} />
										}
										{this.state.historyLoading != 'loading' &&
											this.state.bulkUploadHistory != undefined &&
											this.state.bulkUploadHistory.length == 0 &&

											<div>No History Found!</div>
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, },
		miscReduce: { phone, agentInfo, token } }
) => ({
	errorMessage, phone, agentInfo, token
});

export default connect(mapStateToProps, null)(UploadHistory);
